<!--
  ~ Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
  ~ This software is the proprietary information of Irian Software Development SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="places-picker">
  <p-chips [(ngModel)]="places" [disabled]="true" [field]="'name'" styleClass="readonly places-chips" data-testid="places-chips"></p-chips>
  <button (click)="openPlacesPopup()" [disabled]="buttonDisabled" class="flat" icon="ui-icon-add"  [label]="'Selecteaza locatii'" pButton
          type="button" data-testid="open-places-popup-btn"></button>
</div>

